import React from 'react';
import WhiteNavbar from "components/Navbars/WhiteNavbar.js";

import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardImg,
    CardTitle,
    Row,
    Col,

} from "reactstrap";

import styled from "styled-components"

const Rabih = styled(CardBody)`
    h5, p {
        color: #ffde59;
    }
`

const Others = styled.div`
    h1 {
        color: #ffde59;
    }
`

const Heading = styled(Col)`
    h2 {
        color: #ffde59
    }
    h5 {
        color: white
    }
    text-align: center;
`

// People in the team
const team = [
    { name: "Jihad", position: "Business Development", image: "" },
    { name: "Ayoub", position: "Production", image: "" },
    { name: "Khalid", position: "Marketing", image: "" },
    { name: "Annika", position: "Project", image: "" },
    { name: "????", position: "Design", image: "" },
]

const Team = () => {
    document.documentElement.classList.remove("nav-open");
    return (
        <div className="section-dark fullBg">
            <WhiteNavbar />
            <div className="team-3">
                <div className="space-top" />
                <br />
                <Row>
                    <Col md="5">
                        <img src={require("../assets/img/logo/SEPLOGO.png")} alt="logo" style={{ maxWidth: "50%" }} />
                    </Col>
                    <Heading md="7" style={{ textAlign: "center", }}>
                        <h2>Smart Event And Production</h2>
                        <h5>The Management Team</h5>
                    </Heading>
                </Row>

                <div className="space-top" />

                <Row>
                    <Col md="12">
                        <Card className="card-profile card-plain">
                            <Row>
                                {/* Mr Rabih */}
                                <Col md="4">
                                    <CardImg top tag="div">
                                        <img
                                            alt="..."
                                            className="img"
                                            src={require("assets/img/placeholder.jpg")}
                                        />
                                    </CardImg>
                                </Col>
                                <Col md="8">
                                    <Rabih className="text-left">
                                        <CardTitle tag="h2">Rabih Al Maila</CardTitle>
                                        <h5>Managing Director</h5>
                                        <p>
                                            rabih@smarteventandproduction.com
                                        </p>
                                        {/* Social media stuff */}
                                        <CardFooter className="pull-left">
                                            <Button
                                                className="btn-just-icon btn-link mr-1"
                                                color="twitter"
                                                href="#pablo"
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                <i className="fa fa-twitter" />
                                            </Button>
                                            <Button
                                                className="btn-just-icon btn-link mr-1"
                                                color="facebook"
                                                href="#pablo"
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                <i className="fa fa-facebook" />
                                            </Button>
                                            <Button
                                                className="btn-just-icon btn-link"
                                                color="google"
                                                href="#pablo"
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                <i className="fa fa-google-plus" />
                                            </Button>
                                        </CardFooter>
                                    </Rabih>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                {/* Other members */}
                <div className="pricing-2" style={{ padding: 0, margin: 0 }}>
                    <Row noGutters={true} style={{ display: "flex" }}>
                        {
                            team.map(({ name, position, img }) => {
                                return (
                                    <Col key={name}>
                                        <Card
                                            className="card-pricing"
                                            data-background="image"
                                            style={{
                                                backgroundImage: img ||
                                                    `url(${require("assets/img/placeholder.jpg")})`,
                                                flexBasis: "100%"
                                            }}
                                        >
                                            <CardBody className="flex-centered">
                                                <Others>
                                                    <h1 style={{ margin: 0, }}>{name}</h1>
                                                    <h6>{position}</h6>
                                                    {/* <p className="card-description">
                                                        rabih@smarteventandproduction.com
                                                    </p> */}
                                                </Others>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default Team;